import { ref } from 'vue'

export const msg = ref('')

export default message => {
  msg.value = message
  setTimeout(_ => { msg.value = '' }, 3000)
}
